<template>
  <div class="max-w-5xl mx-auto mt-20" v-if="agents">
    <div>
      <h1
        class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
      >
        Meet the Agents
      </h1>
      <header class="flex items-center justify-between px-2 mb-4 md:px-0">
        <a
          href="registration-enquiry"
          class="mt-2 text-sm font-normal capitalize text-secondary"
          >Register to become a verified agent</a
        >
      </header>

      <div class="mx-4 md:mx-0">
        <vue-horizontal
          responsive
          class="horizontal"
          :displacement="0.7"
          snap="center"
        >
          <div class="flex space-x-4">
            <a
              :href="
                $router.resolve({
                  name: 'AgentView',
                  params: {
                    id: agent.id,
                    slug: agent.name ? $sanitizeTitle(agent.name) : '',
                  },
                }).href
              "
              v-for="agent in agents.data"
              :key="agent.id"
              class="flex flex-col items-center justify-center w-48 h-full p-5 rounded-xl hover:bg-gray-100"
            >
              <div class="p-1 border rounded-full border-primary">
                <img
                  :src="agent.photo ? agent.photo : `img/agent.jpg`"
                  class="bg-contain rounded-full h-36 w-36"
                  alt=""
                />
              </div>
              <div class="flex flex-col items-center justify-center mt-3">
                <p class="font-semibold leading-tight text-center">
                  {{ agent.name }}
                </p>
                <p class="text-sm font-light text-center" v-if="agent.company">
                  {{ agent.company.name ?? "" }}
                </p>
              </div>
            </a>
          </div>
        </vue-horizontal>
      </div>
    </div>
  </div>
</template>
<script>
import VueHorizontal from "vue-horizontal";
export default {
  components: {
    VueHorizontal,
  },
  props: {
    agents: Object,
  },
  data() {
    return {};
  },
};
</script>
